import {useCallback, useRef, useSyncExternalStore} from 'react'

export function useElementPosition(element: HTMLElement | null) {
  const heightCache = useRef(0)

  const subscribeToResize = useCallback(
    (notify: () => void) => {
      if (!element) return () => undefined
      const observer = new ResizeObserver(notify)
      observer.observe(element)
      return () => {
        observer.unobserve(element)
        observer.disconnect()
      }
    },
    [element],
  )

  return useSyncExternalStore(subscribeToResize, () => {
    // If any of the elements are not present, return 0.
    // This can occur when the staffbar is disabled.
    if (!element) return 0

    const height = element.clientHeight
    if (height === heightCache.current) return heightCache.current
    heightCache.current = height
    return height
  })
}

export const useSiteHeaderHeight = () => {
  const headerHeight = useElementPosition(document.querySelector<HTMLElement>('.AppHeader'))
  const staffBarHeight = useElementPosition(document.querySelector<HTMLElement>('#serverstats'))
  const issueStickyHeaderHeight = useElementPosition(
    document.querySelector<HTMLElement>('.primary-viewer .js-notification-shelf-offset-top'),
  )

  // If the issue sticky header is present, use its height,
  // otherwise, use the header and staff bar heights combined.
  return issueStickyHeaderHeight || headerHeight + staffBarHeight
}
